import React, {Component} from "react";
import {Alert, Button, Card, Container, Spinner} from "react-bootstrap";
import numberSeparator from "number-separator";
import dateFormat from "dateformat";
import './loan-info.css'
import {withTranslation} from "react-i18next";

class LoanInfo extends Component {
    getButtonSpinner = () => {
        const {payment: {loading}} = this.props
        if (loading) {
            return <Spinner animation="border" size="sm"/>
        }
        return null
    }

    getLoanInfo = () => {
        const {loan: {data, loading, error}, t} = this.props
        if (loading || error !== null || data === null) {
            return null
        }

        const {
            loans_info: {current_plan_payment: {totalAmount, date}},
            customer: {firstname, middlename, lastname, iin}
        } = data
        const {createPayment} = this.props
        return (
            <React.Fragment>
                <div className="apay-loan-info-name">
                    {lastname} {firstname} {middlename}<br/>
                    {t("loanInfo.iin")} {iin}
                </div>
                <div className="apay-loan-info-date mt-1">
                    {t("loanInfo.monthlyPayment.label", {date: dateFormat(date, "dd.mm.yyyy").toLowerCase() })}
                </div>
                <div className="apay-loan-info-amount mt-3 text-center">
                    {numberSeparator(totalAmount)} {t("loanInfo.kzt.label")}
                </div>
                <Button
                    type="submit"
                    variant="primary apay-loan-info-btn w-100 mt-3"
                    onClick={createPayment}
                > {this.getButtonSpinner()} {t("loanInfo.payBtn.label")}</Button>
                <div className="apay-loan-info-hint mt-2">
                    {t("loanInfo.payBtn.hint")}
                </div>
            </React.Fragment>
        )
    }

    getSpinner = () => {
        const {loan: {loading}} = this.props
        if (loading) {
            return (
                <div><Spinner animation="border"/> Loading...</div>
            )
        }
        return null
    }

    getErrorMessage = () => {
        const {loan: {error}, onStartPage, t} = this.props

        if (error !== null) {
            return (
                <Alert variant='danger'>
                    {t("errors.getLoanInfo")}<br/>
                    <Button onClick={() => {
                        onStartPage()
                    }}>{t("loanInfo.tryBtn.label")}</Button>
                </Alert>
            )
        }
        const {payment: {error: paymentError}} = this.props
        if (paymentError !== null) {
            return (
                <Alert variant='danger'>
                    {t("errors.getPaymentLink")}<br/>
                </Alert>
            )
        }
        return null
    }

    render() {



            const {loan:{data, loading},backToShopLink, t} = this.props

        if (data === null && loading) {
            return <div>Loading</div>
        } else {
            return (
                <Container className="d-flex flex-row justify-content-center h-100">

                    <div className="apay-loan-info mt-5">
                        <div className="apay-loan-info-title">
                            {t("loanInfo.title")}
                        </div>

                        <Card className="rounded-5 p-2">
                            <Card.Body>
                                {this.getErrorMessage()}
                                {this.getSpinner()}
                                {this.getLoanInfo()}
                            </Card.Body>
                        </Card>
                        {backToShopLink}
                    </div>
                </Container>
            )
        }
    }
}

export default withTranslation()(LoanInfo)